function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SaleListingTypeKeys } from '@domain-group/fe-allhomes-library/lib/node';
import { BooleanFilter } from '../boolean-search-query-field';
export class OnlyWithPriceFilter extends BooleanFilter {
  constructor() {
    super(...arguments);
    _defineProperty(this, "urlSlug", OnlyWithPriceFilter.urlSlug);
  }
  get validListingTypes() {
    return [...SaleListingTypeKeys, 'DEVELOPMENTS_RESIDENTIAL'];
  }
  static fromUrlParameters(searchOptions, q) {
    return new OnlyWithPriceFilter(searchOptions, BooleanFilter.parse(q[OnlyWithPriceFilter.urlSlug]));
  }
}
_defineProperty(OnlyWithPriceFilter, "urlSlug", 'withprice');